/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
import { Pagination, Row } from "@themesberg/react-bootstrap"
import React from "react"
import _ from "lodash"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDoubleLeft, faAngleDoubleRight } from "@fortawesome/free-solid-svg-icons";
import { Toast } from "bootstrap";


export default ({currentPage, totalPage, onChange, size = 0, total = 0}) => {
    
    const gap = 10;
    var start = 0;
    var psize = 15;
    var end = (start + psize < totalPage) ? start + psize : totalPage;
    
    if(currentPage + 1 >= gap && totalPage > gap) {
      const mod = currentPage / gap

      //console.log(">> %",gap, currentPage,  gap % currentPage, currentPage % gap)
      start = gap * parseInt(mod) - 1
      end = (start + psize < totalPage) ? start + psize : totalPage;
    }

    if(currentPage + 1 + gap >= totalPage && totalPage > gap){
      start = totalPage - psize
      end = (start + psize < totalPage) ? start + psize : totalPage;
    }

    // if(currentPage > gap * 2) {
    //   start = gap * 2;
    //   end = start + psize;
    // }

    // if(currentPage > gap * 3) {
    //   start = gap * 3;
    //   end = start + psize;
    // }

    if(currentPage >= totalPage - 1 && totalPage > gap) {
      start = totalPage - psize;
      end = start + psize;
    }

    if(total == 0 || size == 0) {
      return (
        <Row>
          <label>{size} of {total}</label>
        </Row>
      )
    }
    
    return (
        <>
        <Row>  
        <label>{size} of {total}</label>
        <br/>
        <div style={{overflowX:'auto'}}>
            <Pagination>
                {(currentPage > 0) && <Pagination.First onClick={()=> {onChange && onChange(0)}}/>}
                {(currentPage > 0) && <Pagination.Prev onClick={()=> {onChange && onChange(currentPage - 1)}}/>}
                
                {(currentPage > gap) && <Pagination.Ellipsis /> }

                {                
                    (_.range(start, end).map(i => {
                        return <Pagination.Item active={currentPage == i} onClick={()=> {onChange && onChange(i)}}>{i + 1}</Pagination.Item>
                    }))
                }

                {(currentPage < gap) && <Pagination.Ellipsis /> }                
                {(currentPage < totalPage -1) && <Pagination.Next onClick={()=> {onChange && onChange(currentPage + 1)}}/>}
                {(currentPage < totalPage -1) && <Pagination.Last onClick={()=> {onChange && onChange(totalPage - 1)}}/>}
            </Pagination>
        </div>
        </Row>
        </>        
    )

}